<template>
    <div class="container-fluid">
        <div class="row mt-3">
            <div class="col-6">
                <h3 class="text-center">{{ article.title }}</h3>
                <div id="editor-container" ref="editor-container" style="height: auto" >
                </div>
                <button class="btn btn-secondary btn-sm mt-3" @click.prevent="$router.go(-1)">Powrót</button>
            </div>
        </div>
        <div class="row mt-5 mb-4">
            <div class="col-8 col-sm-8 col-md-8">
                <h5 class="">Komentarze</h5>
            </div>
            <div class="col-8 col-sm-8 col-md-8">
                <div class="row">
                    <div class="col-4 col-sm-4 col-md-4">
                        <div class="form-group input-group-sm">
                            <textarea class="form-control" rows="3" v-model="commentForm.content"></textarea>
                        </div>
                        <div class="form-group input-group-sm">
                            <button class="btn btn-success torre-btn btn-sm mr-2" @click.prevent="addComment()" >Komentuj</button>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="comment in comments" :key="comment.id">
                    <div class="col-4 mt-3">
                        <div class="card">
                            <div class="card-body">
                                <p class="card-text" v-html="comment.content"></p>
                                <div class="card-footer text-muted">
                                    {{ commentTitle(comment) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import alertify from 'alertifyjs';
import un from 'underscore'
import Quill from "quill"
import ArticlesService from "@/components/articles/ArticlesService"
import moment from 'moment'
import Formatter from "@/service/Formatter"

const formatter = new Formatter()
const articlesService = new ArticlesService()

export default {
    name: "ArticlesShow",
    data() {
        return {
            comments: [],
            commentForm: {
                content: "",
                articleId: this.$route.params.id,
                createDate: moment().format("YYYY-MM-DD HH:mm:ss")
            },
            form: {
                articleId: this.$route.params.id
            },
            quill: "",
            article: {
                content: "",
                title: ""
            }
        }
    },
    mounted() {
        this.loadArticle()
    },
    methods: {
        commentTitle(comment) {
            return `${formatter.date.YMDHHmm(comment.date)} ${comment.createdBy}`
        },
        addComment() {
            articlesService.addComment(this.commentForm, this.onAddCommentSuccess, this.onAddCommentError)
        },
        onAddCommentSuccess(data) {
            alertify.set('notifier','position', 'top-center');
            alertify.success("Komentarz został dodany").delay(3);
            this.loadArticle()
            this.commentForm.content = ""
        },
        loadArticle() {
            articlesService.loadArticle(this.form, this.onLoadSuccess, this.onLoadError)
        },
        onLoadSuccess(data) {
            this.article = data
            this.comments = data.comments
            this.initEditor()
        },
        onLoadError(err) {
            console.log(err)
            this.$router.push({name: 'articles'})
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można pobrać wydatku.").delay(3);
        },
        initEditor: function() {
            this.noteEl = this.$refs['editor-container'];
            this.noteEl.innerHTML = this.article.content;
            this.quill = new Quill(this.noteEl, {
                modules: {
                    toolbar: false
                },
                theme: 'snow',
                readOnly: true
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/articles/ArticlesShow.vue